<template>
  <div class="wrap">
    <Nav :title="$t('goods.history')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <List url="/loan/lists">
        <template #item="{ item }">
          <div class="order">
            <div class="order_detail">
              <div class="detail_item">
                <div class="label">{{ $t('orderNo') }}:</div>
                <div class="value">{{ item.loan_no }}</div>
              </div>
              <div class="detail_item">
                <div class="label">{{ $t('loanAmount') }}:</div>
                <div class="value">{{ item.money }}</div>
              </div>
              <div class="detail_item">
                <div class="label">{{ $t('terms') }}:</div>
                <div class="value">{{ item.expect }}</div>
              </div>
              <div class="detail_item">
                <div class="label">{{ $t('interestRate') }}:</div>
                <div class="value">{{ Number(item.rate || 0) }}%</div>
              </div>
              <div class="detail_item">
                <div class="label">{{ $t('totalRepayAmount') }}:</div>
                <div class="value">{{ item.total_money }}</div>
              </div>
              <div class="detail_item">
                <div class="label">{{ $t('applyTime') }}:</div>
                <div class="value">{{ item.indate && $format(item.indate, 'yyyy-MM-dd') }}</div>
              </div>
              <div class="detail_item">
                <div class="label">{{ $t('状态') }}:</div>
                <div class="value">{{ getStatus(item.status) }}</div>
              </div>
            </div>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>
<script>
import { Icon, Toast } from "vant";
import Nav from "@/components/Navbar";
import List from "@/components/List"
export default {
  components: {
    [Icon.name]: Icon,
    Nav,
    List
  },
  data() {
    return {

    }
  },
  methods: {
    getStatus(status) {
      switch (status) {
        case -1:
          return this.$t('待审核')
          break;
        case 0:
          return this.$t('待放款')
          break;
        case 1:
          return this.$t('还款中')
          break;
        case 2:
          return this.$t('已完成')
          break;
        case 3:
          return this.$t('审核拒绝')
          break;
        case 5:
          return this.$t('逾期')
          break;
        default:
          break;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: var(--newbg);

  .content {
    padding: 0 calc(15rem / 16);

    .order {
      &_detail {
        background-color: var(--white);
        margin-top: calc(20rem / 16);
        border-radius: calc(4rem / 16);

        .detail_item {
          display: flex;
          align-items: center;
          padding: calc(10rem / 16) calc(15rem / 16);
          column-gap: calc(15rem / 16);

          .label,
          .value {
            flex: 1;
          }

          .label {
            color: #999;
            font-size: calc(14rem / 16);
          }

          .value {
            color: #333;
            font-size: calc(16rem / 16);
            text-align: right;
          }
        }
      }
    }
  }
}
</style>